import common from "../../utils/common";
import c from "../../utils/constants";
import env from "../../utils/env";
import _ from "underscore";

class BotSessionDetailsController {

  constructor($stateParams, BotSessionsService, AppContextService, NotificationService) {
    "ngInject"
    this.botSessionsService = BotSessionsService;
    this.appContextService = AppContextService;
    console.log($stateParams.botSessionId);
    this.botSessionId = $stateParams.botSessionId;
    this.getSessionDetails(this.botSessionId);
    this.imageBaseUrl = env.getStorageUrl() + "images/";
    this.deleteIntercomAccount = true;
    this.notificationService = NotificationService;
  }

  $onInit() {
    this.tabTypes = {
      PROFILE: 1,
      PAYMENT: 2,
      JOBS_AND_RATINGS: 3,
      CERTIFICATES: 4,
      MESSAGES: 5,
      RATINGS: 6,
    };
  }

  getSessionDetails(botSessionId) {
    this.isLoading = true;

    this.botSessionsService.getSessionDetails(botSessionId, (response) => {
      this.botSession = response.data;
      this.isLoading = false;

      this.getTabs();
    },
    (error) => {
      this.isLoading = false;
    })
  }

  getTabs() {
    this.tabs = {
      [this.tabTypes.PROFILE]: {
        key: 1,
        label: "PROFILE",
        isActive: true,
        icon: "fa fa-user",
      },
      [this.tabTypes.PAYMENT]: {
        key: 2,
        label: "PAYMENT",
        isActive: false,
        icon: "fa fa-dollar",
      },
      [this.tabTypes.JOBS_AND_RATINGS]: {
        key: 3,
        label: "JOBS & RATINGS",
        isActive: false,
        icon: "fa fa-user",
      },
      [this.tabTypes.MESSAGES]: {
        key: 4,
        label: "MESSAGES",
        isActive: false,
        icon: "fa fa-envelope",
      },
    }
  this.activeTab = this.tabs["1"];

  }

  switchTab(tab) {
    this.activeTab = tab;

    Object.keys(this.tabs).map((i) => {
      if(this.tabs[i] == this.activeTab) this.tabs[i].isActive = true;
      else this.tabs[i].isActive = false;
    })
  }

  formatDate(date) {
    return common.formatDate(date);
  }

  hasGlobalAdminAccess() {
    const appContext = this.appContextService.getAppContext();
    if (!appContext)
      return false;

    if(this.appContextService.hasGlobalAdminAccess(appContext.roles))
      return true;
    else
      return false;
  }

}

export default BotSessionDetailsController;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/containers/bot-session-details/bot-session-details.controller.js
 **/